import React, { FunctionComponent } from 'react'
import { IndividualIconProps } from '../../../types'
import getIconSize from '../../../utils/getIconSize'

const SvgGroup: FunctionComponent<IndividualIconProps> = props => {
  const sizeInPixels = getIconSize(props.size)
  return (
    <svg
      {...props}
      width={sizeInPixels}
      height={sizeInPixels}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2621 10.0539C19.765 9.55675 18.959 9.55675 18.4618 10.0539C17.9647 10.551 17.9647 11.357 18.4618 11.8542C18.959 12.3513 19.765 12.3513 20.2621 11.8542C20.7593 11.357 20.7593 10.551 20.2621 10.0539ZM21.3219 8.99237C20.2389 7.9103 18.4838 7.91059 17.4012 8.99322C16.3183 10.0761 16.3183 11.8319 17.4012 12.9148C18.4841 13.9978 20.2399 13.9978 21.3228 12.9148C22.4057 11.8319 22.4057 10.0761 21.3228 8.99322L21.3219 8.99237Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.949 15.4041C18.949 14.9898 19.2848 14.6541 19.699 14.6541H20.5C22.2952 14.6541 23.75 16.1088 23.75 17.9041V19.0001C23.75 19.4143 23.4142 19.7501 23 19.7501C22.5858 19.7501 22.25 19.4143 22.25 19.0001V17.9041C22.25 16.9373 21.4668 16.1541 20.5 16.1541H19.699C19.2848 16.1541 18.949 15.8183 18.949 15.4041Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53813 10.0539C5.041 9.55675 4.23498 9.55675 3.73784 10.0539C3.24071 10.551 3.24071 11.357 3.73784 11.8542C4.23498 12.3513 5.041 12.3513 5.53813 11.8542C6.03527 11.357 6.03527 10.551 5.53813 10.0539ZM6.59794 8.99237C5.51494 7.9103 3.75982 7.91059 2.67718 8.99322C1.59426 10.0761 1.59426 11.8319 2.67718 12.9148C3.76011 13.9978 5.51587 13.9978 6.59879 12.9148C7.68172 11.8319 7.68172 10.0761 6.59879 8.99322L6.59794 8.99237Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 16.1541C2.53321 16.1541 1.75 16.9373 1.75 17.9041V19.0001C1.75 19.4143 1.41421 19.7501 1 19.7501C0.585786 19.7501 0.25 19.4143 0.25 19.0001V17.9041C0.25 16.1088 1.70479 14.6541 3.5 14.6541H4.301C4.71521 14.6541 5.051 14.9898 5.051 15.4041C5.051 15.8183 4.71521 16.1541 4.301 16.1541H3.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6723 6.44269C12.7487 5.5191 11.2513 5.5191 10.3277 6.44269C9.40411 7.36629 9.40411 8.86372 10.3277 9.78731C11.2513 10.7109 12.7487 10.7109 13.6723 9.78731C14.5959 8.86371 14.5959 7.36628 13.6723 6.44269ZM14.7326 5.38165C13.2232 3.87266 10.7763 3.87278 9.26704 5.38203C7.75767 6.89141 7.75766 9.3386 9.26704 10.848C10.7764 12.3573 13.2236 12.3573 14.733 10.848C16.2423 9.33859 16.242 6.89103 14.7326 5.38165Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91003 17.399C5.91003 15.0518 7.81282 13.149 10.16 13.149H13.839C16.1862 13.149 18.089 15.0518 18.089 17.399V19C18.089 19.4143 17.7532 19.75 17.339 19.75C16.9248 19.75 16.589 19.4143 16.589 19V17.399C16.589 15.8803 15.3578 14.649 13.839 14.649H10.16C8.64125 14.649 7.41003 15.8803 7.41003 17.399V19C7.41003 19.4143 7.07425 19.75 6.66003 19.75C6.24582 19.75 5.91003 19.4143 5.91003 19V17.399Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgGroup
